import React from 'react';
import AboutMe from './components/AboutMe/AboutMe';
import Header from './components/Header/Header';
import Projects from './components/Projects/Projects';
import styles from './App.module.css';
import AboutMeSide from './components/AboutMe/AboutMeSide';

function App() {
  // when in prod, don't be outputting to console.
  if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};
  }
  // console.log('test');

  return (
    <>
      <Header />
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <AboutMeSide />
        </div>
        <div className={styles.right}>
          <AboutMe />
          <Projects />
        </div>
      </div>
    </>
  );
}

export default App;
